class DashboardAppearanceConfig {
    backgroundColor: KnockoutObservable<string>;
    widgetDefaultBackgroundColor: KnockoutObservable<string>;

    constructor(data: any) {
        this.backgroundColor = ko.observable(data.backgroundColor);
        this.widgetDefaultBackgroundColor = ko.observable(data.widgetDefaultBackgroundColor);
    }
}